import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function ReviewSection() {
  const ref = useScrollReveal();

  return (
    <section className="w-full bg-white py-12 px-6">
      <div ref={ref} className="section-reveal max-w-2xl mx-auto">
        <p className="text-xs font-medium text-[#9A9A9A] tracking-[0.2em] uppercase mb-3">Policy</p>
        <div className="w-10 h-px bg-[#E0E0E0] mb-3" />
        <div className="text-xl md:text-2xl font-bold text-[#1A1A1A] tracking-wide mb-10">大切にしていること</div>

        <div className="space-y-5 text-[15px] md:text-base leading-[1.95] text-[#333333]">
          <p>
            すべてのレビューは、実際に手にして使った経験をもとにしています。
            頭の中の印象ではなく、日常的に使ってみてはじめてわかることを、大切にお伝えしています。
          </p>
          <p>
            提供品であっても、感じたことを率直に伝えることを心がけています。
            良い点だけでなく、気になる点や惜しい部分も含めて発信するのが、私のスタンスです。
          </p>
          <p>
            この姿勢は、ブログでも動画でも変わりません。
            観ていただける方が、自分にとって本当に必要なものを選べるような情報を届けたいと思っています。
          </p>
        </div>

        <div className="mt-10 pl-5 border-l-2 border-[#DDDDDD]">
          <p className="text-[13px] leading-relaxed text-[#9A9A9A] italic">
            ※ 提供品・案件であることは、必ず明示した上で発信しています。
          </p>
        </div>
      </div>
    </section>
  );
}
